module.exports = __webpack_public_path__ + "static/media/madison.68839355.png";